import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";

const ContactForm = () => {
  const [loading, setLoading] = useState(false);
  const [forms, setForms] = useState({
    firstName: "",
    lastName: "",
    email: "",
    location: "",
    subject: "",
    phoneNumber: "",
    message: "",
  });

  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
  };

  const submitHandler = async (e) => {
    setLoading(true);
    e.preventDefault();
    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/contact-us`,
      forms
    );
    if (res.status === 201) {
      toast.success("Contact Us Requested Successfully", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setForms({
        firstName: "",
        lastName: "",
        email: "",
        location: "",
        subject: "",
        phoneNumber: "",
        message: "",
      });
      setLoading(false);
    } else {
      toast.error("Contact Us Request Failed", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={(e) => submitHandler(e)}
      className="contact-validation-active"
    >
      <div className="row">
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.firstName}
              type="text"
              name="firstName"
              required
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              placeholder="Your First Name"
            />
          </div>
        </div>
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.lastName}
              type="text"
              name="lastName"
              required
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              placeholder="Your Last Name"
            />
          </div>
        </div>
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.email}
              type="email"
              name="email"
              required
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              placeholder="Your Email"
            />
          </div>
        </div>
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.phoneNumber}
              type="phone"
              name="phoneNumber"
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              placeholder="Your phone"
            />
          </div>
        </div>
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.location}
              type="location"
              name="location"
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              placeholder="Your Address"
            />
          </div>
        </div>
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.subject}
              type="subject"
              name="subject"
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              placeholder="Your Subject"
            />
          </div>
        </div>

        <div className="col col-lg-12 col-12">
          <textarea
            onBlur={(e) => changeHandler(e)}
            onChange={(e) => changeHandler(e)}
            value={forms.message}
            type="text"
            name="message"
            required
            placeholder="Message"
          ></textarea>
        </div>
      </div>
      <div className="submit-area">
        <button type="submit" className="theme-btn" disabled={loading}>
          <i className="fa fa-angle-double-right" aria-hidden="true"></i>{" "}
          {loading ? "Sending..." : "Submit Now"}
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
